import { Injectable } from '@angular/core';

@Injectable()
export class SolidSessionService {

    get userId(): number | undefined {
        return solid.session.userId;
    }

    get tenantId(): number | undefined {
        return solid.session.tenantId;
    }

    get impersonatorUserId(): number | undefined {
        return solid.session.impersonatorUserId;
    }

    get impersonatorTenantId(): number | undefined {
        return solid.session.impersonatorTenantId;
    }

    get multiTenancySide(): solid.multiTenancy.sides {
        return solid.session.multiTenancySide;
    }

}